/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonthStatistics } from './monthStatistics';


/**
 * Статистика для объявлений за период с разбивкой по месяцам.
 */
export interface LoyaltyStatisticsByMonths { 
    /**
     * Дата начала выборки статистики.
     */
    dateStart?: string;
    /**
     * Дата конца  выборки статистики.
     */
    dateEnd?: string;
    /**
     * ID объединения, для которого запрошена статистика.
     * @deprecated
     */
    parentOrganisationId?: string;
    /**
     * Массив ID объединений, которые участвуют в статистике.
     */
    parentOrganisationIds?: Array<string>;
    /**
     * Кол-во продуктов ПЛ.
     */
    productsCount?: number;
    /**
     * Массив статистики по месяцам.
     */
    months?: Array<MonthStatistics>;
}

